import Actions from '../constants/Actions';
import History from '../client/History';
import Settings from '../utils/Settings';
import merge from 'lodash.merge';

//TODO: Create a mechanism to flash messages - flashMessageStore, etc.  Messages will timeout after a set time (i.e. 5 seconds) or if the user clicks dismiss
export async function sidebarToggleClicked(context) {
  context.dispatch(Actions.SIDEBAR_TOGGLE_CLICKED);
}

export async function getFavorites(context) {
  const { data: favorites } = await context.service.read('favorite', {});

  context.dispatch(Actions.FAVORITES_RECEIVED, favorites);
}

export async function addFavorite(context, favorite) {
  const { data: favorites } = await context.service.create('favorite', {}, favorite);
  context.dispatch(Actions.FAVORITES_ADDED, [favorite]);

  context.dispatch(Actions.FAVORITES_RECEIVED, favorites);
}

export async function removeFavorite(context, { url }) {
  const { data: favorites } = await context.service.delete('favorite', {
    url
  });
  context.dispatch(Actions.FAVORITES_REMOVED, {
    url
  });

  context.dispatch(Actions.FAVORITES_RECEIVED, favorites);
}

export async function replaceQueryParameters(context, queryParams) {
  await context.executeAction(replaceAndUnsetQueryParameters, {
    queryParams
  });
}

export async function unsetQueryParameters(context, keysToRemove) {
  await context.executeAction(replaceAndUnsetQueryParameters, {
    keysToRemove
  });
}

export async function replaceAndUnsetQueryParameters(context, { queryParams = {}, keysToRemove = [] }) {
  if (Settings.inBrowser) {
    const history = History.get();
    const location = history.createLocation(window.location);
    const query = location.query || {};

    merge(query, queryParams);
    keysToRemove.forEach(key => {
      delete query[key];
    });
    location.query = query;

    const finalLocation = history.createLocation(location);
    finalLocation.search = '';
    history.push(finalLocation);
  }
}

export async function clearListFilter(context) {
  context.dispatch(Actions.LIST_FILTER_CLEAR);
}

export async function setListFilter(context, value) {
  context.dispatch(Actions.LIST_FILTER_SET, value);
}

export async function postLog(context, message) {
  await context.service.create('logger', {}, message);
}



// WEBPACK FOOTER //
// ./src/actions/CommonActionCreators.js